import { memo } from "react";
import {
  BaseEdge,
  getBezierPath,
  type EdgeProps,
} from "@xyflow/react";
import type { ExpressionEdgeData } from "@/types/decision-graph";

export const ExpressionEdge = memo(function ExpressionEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  selected = false,
  markerEnd,
}: EdgeProps) {
  const edgeData = data as ExpressionEdgeData | undefined;
  const edgeType = edgeData?.edgeType ?? "value";

  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const isBoolean = edgeType === "boolean";
  const strokeColor = isBoolean ? "#22c55e" : "#6366f1";
  const selectedStrokeColor = isBoolean ? "#16a34a" : "#4f46e5";

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: selected ? selectedStrokeColor : strokeColor,
          strokeWidth: selected ? 2.5 : 1.5,
          strokeOpacity: selected ? 1 : 0.8,
        }}
        markerEnd={markerEnd}
      />

      {selected && (
        <path
          d={edgePath}
          fill="none"
          stroke={strokeColor}
          strokeWidth={1.5}
          strokeDasharray="6 4"
          strokeLinecap="round"
          style={{
            animation: "flowEdge 0.5s linear infinite",
          }}
        />
      )}
    </>
  );
});

if (typeof document !== "undefined") {
  const styleId = "expression-edge-animations";
  if (!document.getElementById(styleId)) {
    const style = document.createElement("style");
    style.id = styleId;
    style.textContent = `
      @keyframes flowEdge {
        from { stroke-dashoffset: 20; }
        to { stroke-dashoffset: 0; }
      }
    `;
    document.head.appendChild(style);
  }
}
